module.exports = __webpack_public_path__ + "f261c4709546c14b912d9e06b92090f1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/tuxedo-s.png
// module id = 1958
// module chunks = 0